import { render, staticRenderFns } from "./action-quotation.vue?vue&type=template&id=02610c8d&"
import script from "./action-quotation.vue?vue&type=script&lang=js&"
export * from "./action-quotation.vue?vue&type=script&lang=js&"
import style0 from "./action-quotation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports